import { gql } from '@apollo/client'

export const DTVFragment = gql`
    fragment dtvFragment on DocumentTemplateView {
        id
        name
        projectId
        productFamilyId
        items {
            itemId
            partType
            type
            parentId
            order
            isForProductType
            isProductType
            isManufacturers
            isBOD
            isProductGroup
            isSharedProductTypeProperty
            isProductGroupHasMultipleProductTypes
            levelOfSpecificationTag
            documentTemplateViewContents {
                contentId
                parentId
                documentTemplateViewContentItems {
                    id
                    parentId
                    order
                    isHidden
                    isDeactivated
                    isUserAdded
                    propertyRefId
                    paragraphOrder
                    isSharedProperty
                    isSustainabilityContentItem
                    isSelectedSustainabilityContentItem
                    topicId
                    topicName
                    topicNumber
                }
            }
        }
    }
`
